






















import TheHeader from "./components/TheHeader.vue";
import TheFooter from "./components/TheFooter.vue";
import store from "./store";
import Vue from "vue";

export default Vue.extend({
  name: "App",
  components: {
    "the-header": TheHeader,
    "the-footer": TheFooter
  },
  data() {
    return {
      registration: (undefined as unknown) as ServiceWorkerRegistration,
      refreshing: false
    };
  },
  computed: {
    transitionName: (): string => {
      return store.state.loadingSettings.transition;
    }
  },
  created(): void {
    document.addEventListener(
      "serviceWorkerUpdateEvent",
      ((event: CustomEvent): void =>
        this.appUpdateUI(event as CustomEvent)) as EventListener,
      {
        once: true
      }
    );

    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });
  },
  methods: {
    appUpdateUI(event: CustomEvent): void {
      this.registration = event.detail;
      this.$bvToast.show("update-toast");
    },
    update(): void {
      this.$bvToast.hide("update-toast");
      if (this.registration && this.registration.waiting) {
        this.registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    }
  }
});
